import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";

const LINES = [
  "A services platform for Malta,",
  "built with its trades",
  "before it opens.",
];

export const Hero = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start start", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["0%", "16%"]);

  return (
    <section className="hero" ref={ref} id="top" data-testid="hero">
      {/* Hero photo: "Golden hour view of the Valletta waterfront, Malta" — Pexels photo 31572519 (pexels.com/photo/31572519) */}
      <motion.div className="hero-bg" style={{ y, backgroundImage: "url('/hero-valletta.jpg')" }} aria-hidden="true" />
      <div className="hero-overlay" aria-hidden="true" />
      <div className="wrap hero-inner">
        <motion.p
          className="eyebrow"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.9, delay: 0.15 }}
          data-testid="hero-eyebrow"
        >
          Founding tasker intake · Malta
        </motion.p>
        <h1 data-testid="hero-heading">
          {LINES.map((line, i) => (
            <span className="mask-line" key={i}>
              <motion.span
                initial={{ y: "115%" }}
                animate={{ y: "0%" }}
                transition={{ duration: 1.15, delay: 0.3 + i * 0.14, ease: [0.16, 1, 0.3, 1] }}
              >
                {line}
              </motion.span>
            </span>
          ))}
        </h1>
        <motion.p
          className="hero-lede"
          initial={{ opacity: 0, y: 22 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, delay: 0.85, ease: [0.16, 1, 0.3, 1] }}
          data-testid="hero-paragraph"
        >
          Sorted is not live yet, and we are not promising you work today. Register
          now as a founding professional, our team calls you personally to discuss
          your business, and you will be among the very first professionals visible
          on the platform the day it opens — with 0% commission on your first 5
          jobs, or for 60 days after your first job, whichever comes first.
        </motion.p>
        <motion.div
          className="hero-cta-row"
          initial={{ opacity: 0, y: 18 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, delay: 1.05, ease: [0.16, 1, 0.3, 1] }}
        >
          <a href="#apply" className="btn-brass" data-testid="hero-cta">
            Become a founding tasker
          </a>
          <span className="hero-caption" data-testid="hero-caption">
            One minute · no fee · no exclusivity
          </span>
        </motion.div>
      </div>
    </section>
  );
};
